// Generated by CoffeeScript 2.7.0
var TableMapper;

export default TableMapper = Vue.extend({
  props: {
    initialSettings: {
      type: Boolean,
      default: false
    }
  },
  template: `<label class='option-group-item'>
  <input type='checkbox'
         hidden='true'
         :checked='checked'
         @click.stop='checkedChangeFunc' />
  <i class='slp-square-o'></i>
  <span class='item-label'>数据映射</span>
</label>`,
  data: function() {
    return {
      checked: false
    };
  },
  methods: {
    getData: function() {
      return this.checked;
    },
    checkedChangeFunc: function() {
      return this.checked = !this.checked;
    }
  }
});
